import { render } from "./AppToast.vue?vue&type=template&id=453f90d8&scoped=true"
import script from "./AppToast.vue?vue&type=script&lang=js"
export * from "./AppToast.vue?vue&type=script&lang=js"

import "./AppToast.vue?vue&type=style&index=0&id=453f90d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453f90d8"]])

export default __exports__